import PropTypes from 'prop-types';

import { useContext } from 'react';

import MaterialsCaptureContext from '../../context/MaterialsCaptureContext';

import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

const IgniteMixingForm = ({ data }) => {
  const { handleInputChange, formErrors } = useContext(MaterialsCaptureContext);

  return(
    <Grid container spacing={1} mt={1}>
      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Labware Type - storage vessel"
          name={`labware_type-${data?.index}`}
          value={data?.labware_type}
          onChange={e => 
            handleInputChange(e, data?.index, 'labware_type', e.target.value)
          }
          helperText={formErrors[`labware_type-${data?.index}`]}
          error={`labware_type-${data?.index}` in formErrors}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Mixer Type"
          name={`mixer_type-${data?.index}`}
          value={data?.mixer_type}
          onChange={e => 
            handleInputChange(e, data?.index, 'mixer_type', e.target.value)
          }
          helperText={formErrors[`mixer_type-${data?.index}`]}
          error={`mixer_type-${data?.index}` in formErrors}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="NanoAssemblr® Ignite™ NxGen™ Cartridge Type"
          name={`cartridge_type-${data?.index}`}
          value={data?.cartridge_type}
          onChange={e => 
            handleInputChange(e, data?.index, 'cartridge_type', e.target.value)
          }
          helperText={formErrors[`cartridge_type-${data?.index}`]}
          error={`cartridge_type-${data?.index}` in formErrors}
          type='number'
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Syringe Payload Phase - Brand"
          name={`payload_phase_brand-${data?.index}`}
          value={data?.payload_phase_brand}
          onChange={e => 
            handleInputChange(e, data?.index, 'payload_phase_brand', e.target.value)
          }
          helperText={formErrors[`payload_phase_brand-${data?.index}`]}
          error={`payload_phase_brand-${data?.index}` in formErrors}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Syringe Payload Phase - Volume (mL)"
          name={`payload_phase_volume-${data?.index}`}
          value={data?.payload_phase_volume}
          onChange={e => 
            handleInputChange(e, data?.index, 'payload_phase_volume', e.target.value)
          }
          helperText={formErrors[`payload_phase_volume-${data?.index}`]}
          error={`payload_phase_volume-${data?.index}` in formErrors}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Syringe Encapsulant Phase - Brand"
          name={`encapsulant_phase_brand-${data?.index}`}
          value={data?.encapsulant_phase_brand}
          onChange={e => 
            handleInputChange(e, data?.index, 'encapsulant_phase_brand', e.target.value)
          }
          helperText={formErrors[`encapsulant_phase_brand-${data?.index}`]}
          error={`encapsulant_phase_brand-${data?.index}` in formErrors}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Syringe Encapsulant phase - Volume (mL)"
          name={`encapsulant_phase_volume-${data?.index}`}
          value={data?.encapsulant_phase_volume}
          onChange={e => 
            handleInputChange(e, data?.index, 'encapsulant_phase_volume', e.target.value)
          }
          helperText={formErrors[`encapsulant_phase_volume-${data?.index}`]}
          error={`encapsulant_phase_volume-${data?.index}` in formErrors}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Syringe Dilution buffer - Brand"
          name={`dilution_buffer_brand-${data?.index}`}
          value={data?.dilution_buffer_brand}
          onChange={e => 
            handleInputChange(e, data?.index, 'dilution_buffer_brand', e.target.value)
          }
          helperText={formErrors[`dilution_buffer_brand-${data?.index}`]}
          error={`dilution_buffer_brand-${data?.index}` in formErrors}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Syringe Dilution Buffer - Volume (mL)"
          name={`dilution_buffer_volume-${data?.index}`}
          value={data?.dilution_buffer_volume}
          onChange={e => 
            handleInputChange(e, data?.index, 'dilution_buffer_volume', e.target.value)
          }
          helperText={formErrors[`dilution_buffer_volume-${data?.index}`]}
          error={`dilution_buffer_volume-${data?.index}` in formErrors}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Flow Rate Ratio C - Payload phase to encapsulant phase"
          name={`flow_ratio_c-${data?.index}`}
          value={data?.flow_ratio_c}
          onChange={e => 
            handleInputChange(e, data?.index, 'flow_ratio_c', e.target.value)
          }
          helperText={formErrors[`flow_ratio_c-${data?.index}`]}
          error={`flow_ratio_c-${data?.index}` in formErrors}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Flow Rate Ratio R - Encapsulant phase to payload phase"
          name={`flow_ratio_r-${data?.index}`}
          value={data?.flow_ratio_r}
          onChange={e => 
            handleInputChange(e, data?.index, 'flow_ratio_r', e.target.value)
          }
          helperText={formErrors[`flow_ratio_r-${data?.index}`]}
          error={`flow_ratio_r-${data?.index}` in formErrors}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Total Volume (mL)"
          name={`total_volume-${data?.index}`}
          value={data?.total_volume}
          onChange={e => 
            handleInputChange(e, data?.index, 'total_volume', e.target.value)
          }
          helperText={formErrors[`total_volume-${data?.index}`]}
          error={`total_volume-${data?.index}` in formErrors}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Start waste (mL)"
          name={`start_waste-${data?.index}`}
          value={data?.start_waste}
          onChange={e => 
            handleInputChange(e, data?.index, 'start_waste', e.target.value)
          }
          helperText={formErrors[`start_waste-${data?.index}`]}
          error={`start_waste-${data?.index}` in formErrors}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="End waste (mL)"
          name={`end_waste-${data?.index}`}
          value={data?.end_waste}
          onChange={e => 
            handleInputChange(e, data?.index, 'end_waste', e.target.value)
          }
          helperText={formErrors[`end_waste-${data?.index}`]}
          error={`end_waste-${data?.index}` in formErrors}
          fullWidth
        />
      </Grid>
    </Grid>
  );
};

IgniteMixingForm.propTypes = {
  data: PropTypes.object.isRequired,
};

export default IgniteMixingForm;